import React, { Fragment, useState } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from "prop-types";

const SubMenu = ({title,icon,link,subMenu,onClick}) => {
    const[expand,setExpand] = useState(false);
    
    const handleExpandSubMenu = () => {
        setExpand(!expand);
    }
    return ( 
        <Fragment>
            <li className='nav-item' onClick={e => onClick()}>
                <NavLink to={link} onClick={e => handleExpandSubMenu()}><img src={icon} className="ms-2" alt='menu-icon'/><span>{title}</span>{subMenu && subMenu.length > 0 ? <i className={expand ? "fa fa-angle-down" : "fa fa-angle-right"}></i>:null}</NavLink>
                    {subMenu && subMenu.length > 0 ?
                        <ul className={expand ? "sub-navbar submenu-active" : "sub-navbar"}>
                            {subMenu.map((x,index) => (
                                <li key={index} className='sub-nav-item'>
                                    <NavLink to={x.to}>{x.name}</NavLink>
                                </li>
                            ))}
                        </ul> 
                    :null}
            </li>
        </Fragment>

     );
}

SubMenu.propTypes = {
    title: PropTypes.string,
    icon: PropTypes.string,
    link: PropTypes.string,
    subMenu: PropTypes.array,
    onClick: PropTypes.func
}
 
export default SubMenu;